<template lang="pug">
	.form-label

		.failed-container(v-if='state === "error"')
			.label.error.spacey
				p(v-html='err')
				span.load-icon(@click='init')
					svg(
						xmlns='http://www.w3.org/2000/svg'
						version='1.1'
						width='512'
						height='512'
						viewBox='0 0 512 512'
					)
						title
						g#icomoon-ignore
						path(
							d='M444.84 83.16c-46.804-51.108-114.077-83.16-188.84-83.16-141.385 0-256 114.615-256 256h48c0-114.875 93.125-208 208-208 61.51 0 116.771 26.709 154.848 69.153l-74.848 74.847h176v-176l-67.16 67.16z'
						)
						path(
							d='M464 256c0 114.875-93.125 208-208 208-61.51 0-116.771-26.709-154.847-69.153l74.847-74.847h-176v176l67.16-67.16c46.804 51.108 114.077 83.16 188.84 83.16 141.385 0 256-114.615 256-256h-48z'
						)

		p.label(v-else v-html='display')
</template>

<script>
export default {
	name : 'form-label',

	props : {
		options : {
			type : Object,
		},

		value : {
			type : [String, Number],
		},

		formValue : {
			type : Object,
		},

		data : {
			type : Object,
		}
	},

	data : () => ( {

		localValue : '',

		err : null,

		state : 'idle',

	} ),

	computed : {

		hasComputedValue() {
			const { getValue } = this.options;

			return ( typeof getValue === 'object' && getValue.type === 'computed' );
		},

		display() {
			const { localValue }  = this;
			const { renderValue } = this.options;

			if ( this.state === 'loading' || this.state === 'idle' ) {
				return this.options.loadingText || '<p class="loading-indicator">Loading<span>.</span><span>.</span><span>.</span>';
			}

			return renderValue ? renderValue( localValue ) : localValue;
		},

	},

	created() {
		this.init();

		const propToWatch = `formValue.${this.options.watchProp}`;

		this.$watch( propToWatch, () => {

			const { renderError }   = this.options;
			const { generateValue } = this;

			this.setValue( generateValue, renderError );
		} );

	},

	watch : {

		value( val ) {
			if ( val !== this.localValue ) {
				this.localValue = val;
			}
		},

		localValue( val ) {
			if ( this.value !== val ) {
				this.$emit( 'input', val );
			}
		},

	},

	methods : {

		init() {

			const { renderError }   = this.options;
			const { generateValue } = this;

			if ( this.value ) {
				this.localValue = this.value;

				this.state = 'loaded';
				return;
			}

			this.setValue( generateValue, renderError );

		},

		setValue( generateValue, renderError ) {

			if ( this.state === 'loading' ) {
				return;
			}

			this.state = 'loading';

			Promise.resolve()
				.then( () => generateValue() )
				.then( ( string ) => {
					this.localValue = string;

					this.state = 'loaded';
				} )
				.catch( ( err ) => {
					this.state = 'error';

					this.err = renderError ? renderError( err ) : 'Could not load value';
				} );

		},

		generateValue() {
			const { getValue } = this.options;

			if ( typeof getValue === 'function' ) {
				return getValue( this.formValue, this.data );
			}

			if ( typeof getValue === 'object' ) {
				if ( getValue.type === 'computed' ) {
					return getValue.generate( this.formValue, this.data );
				}
			}

			throw new Error( 'Cannot determine generate value function' );
		},

	},
};
</script>

<style lang="scss">
	.form-label {

		.failed-container {
			display: flex;
			flex-flow: row nowrap;
			justify-content: center;
			align-items: center;

			.label.error {
				position: relative;

				p {
					color: $error;
				}

				.load-icon {
					font-weight: 600;
					position: absolute;
					right: -5px;
					top: 50%;
					transform: translate(100%, -50%);
					color: inherit;
					cursor: pointer;

					svg {
						height: 16px;
						width: 16px;
						fill: $error;
					}
				}
			}
		}
	}
</style>
